import type {
  Cluster,
  ClusterStats,
  Marker,
  Renderer,
} from "@googlemaps/markerclusterer";

import { t } from "i18next";

export class MapClusterRenderer implements Renderer {
  public render(
    { count, position }: Cluster,
    _stats: ClusterStats,
    map: google.maps.Map
  ): Marker {
    const svg = `<svg fill="#008cff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="50" height="50">
<circle cx="120" cy="120" opacity=".8" r="70" />
<circle cx="120" cy="120" opacity=".3" r="90" />
<text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="50" dominant-baseline="middle" font-family="roboto,arial,sans-serif">${count}</text>
</svg>`;

    const title = t("global:mapClusterCount", { count });

    // adjust zIndex to be above other markers
    const zIndex: number = 10000 + count;

    const parser = new DOMParser();
    const svgEl = parser.parseFromString(svg, "image/svg+xml").documentElement;
    svgEl.setAttribute("transform", "translate(0 25)");

    const clusterOptions: google.maps.marker.AdvancedMarkerElementOptions = {
      map,
      position,
      zIndex,
      title,
      content: svgEl,
    };
    return new google.maps.marker.AdvancedMarkerElement(clusterOptions);
  }
}
